import ReactDOM from 'react-dom/client'
import App from './App'
// Allow us to create the Store
import { createStore, applyMiddleware } from 'redux'
//Connect to the Store
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import reducer from './reducer'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'

export const checkInternal = () => isInternal
export let isInternal = false

declare global {
  interface Window {
    renderCart: any
    unmountCart: any
  }
}
// Create the Store
const composeEnhancers = composeWithDevTools({ name: 'Cart - MicroFrontend' })
const myStore = createStore(reducer, {}, composeEnhancers(applyMiddleware(thunk)))
let root: ReactDOM.Root
const loadMicroFrontend = (containerId: string, internal: boolean = false) => {
  root = ReactDOM.createRoot(document.getElementById(containerId) as HTMLElement)
  isInternal = internal
  root.render(
    <Provider store={myStore}>
      <App />
    </Provider>
  )
}

let element: any = null

window.renderCart = (containerId: string, isInternal: boolean) => {
  loadMicroFrontend(containerId, isInternal)
  element = document.getElementById(containerId)
}

window.unmountCart = () => {
  if (element) root.unmount()
}

//To RUN LOCAL
if (!document.getElementById('Cart-container')) {
  loadMicroFrontend('root')
}
